import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-route-create',
  templateUrl: './app-route-create.component.html',
  styleUrls: ['./app-route-create.component.scss']
})
export class AppRouteCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
